
import SimpleEvent from './../../zviz2/zviz/event';
import {scrollY, scrollTo} from './../../tools';


class Subnav{

    constructor(){

        this.events = [];
        this.closeEvents = {};
        this.index = 0;

        this.element = document.getElementById('subnav');
        this.header = document.getElementById('header');
        this.links = this.element.getElementsByClassName('subnavItem');
        this.events.push(new SimpleEvent(window, 'scroll', [this, this.scroll]));
        this.events.push(new SimpleEvent(window, 'hashchange', [this, this.hashChange]));
        this.scroll();

        for(let i = 0; i < this.links.length; i++){
            this.events.push(new SimpleEvent(this.links[i], 'click', [this, this.linkClick]));
        }

        let elms = this.element.getElementsByClassName('previous');
        if(elms && elms[0]){
            this.events.push(new SimpleEvent(elms[0], 'click', [this, this.previous]));
        }

        elms = this.element.getElementsByClassName('next');
        if(elms && elms[0]){
            this.events.push(new SimpleEvent(elms[0], 'click', [this, this.next]));
        }

        let elm = document.getElementById('backToTop');
        if(elm){
            this.events.push(new SimpleEvent(elm, 'click', [this, this.toTop]));
        }

        // if(window.location.hash && window.location.hash.length > 2){
        //     if(window.location.hash.length <= 5 || window.location.hash.substring(1,5) != 'ind_'){
        //         let id = window.location.hash.replace('#', 'bkmrk_');
        //         let link = document.getElementById(id);
        //         if(link){
        //             let c = scrollTo(link, 500, true);
        //             c.start();
        //         }
        //     }
        // }
        this.events.push(new SimpleEvent(document.getElementById('shareFacebook'), 'click', [this, this.shareLink, 'facebook']));
        this.events.push(new SimpleEvent(document.getElementById('shareTwitter'), 'click', [this, this.shareLink, 'twitter']));
        this.events.push(new SimpleEvent(document.getElementById('shareLinkedIn'), 'click', [this, this.shareLink, 'linkedin']));
        this.events.push(new SimpleEvent(document.getElementById('shareGooglePlus'), 'click', [this, this.shareLink, 'googleplus']));
        this.events.push(new SimpleEvent(document.getElementById('shareMail'), 'click', [this, this.shareLink, 'mail']));

    }

    shareLink(event, type){
        event.preventDefault();

        let url = window.location.href;

        if(type == 'facebook'){
            var sharer = "https://www.facebook.com/sharer/sharer.php?u=";
            window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), 'facebook', 'width=626,height=436');
        }
        if(type == 'twitter'){
            let text = '';
            if(window.twitterText){
                text = window.twitterText;
            }else{
                let elm = document.getElementsByName('description');
                if(elm && elm[0]){
                    text = elm[0].getAttribute('content') || '';
                }
            }
            var sharer = "https://twitter.com/share?text="+encodeURIComponent(text)+"&url=";
            window.open(sharer + encodeURIComponent(url), 'twitter', 'width=626,height=436');
        }
        if(type == 'linkedin'){
            window.open('https://www.linkedin.com/cws/share?url=' + encodeURIComponent(url), 'linkedin', 'width=626,height=436');
        }
        if(type == 'googleplus'){
            window.open('https://plus.google.com/share?url=' + encodeURIComponent(url), 'googleplus', 'width=626,height=436');
        }
        if(type == 'mail'){
            let elm = document.getElementsByTagName('title');
            let title = '';
            let text = '';
            if(elm && elm[0]){
                title = elm[0].textContent;
            }
            if(window.shareText){
                text = window.shareText;
            }else{
                let elm = document.getElementsByName('description');
                if(elm && elm[0]){
                    text = elm[0].getAttribute('content') || '';
                }
            }
            window.location.href = 'mailto:?subject=' + encodeURIComponent(title) +'&body=' + encodeURIComponent(text);
        }

        zolabo.trackEvent('social', type, url);

    }

    toTop(event){
        event.preventDefault();
        let c = scrollTo(document.body, 300, true, 0);
        c.start();
    }

    previous(event){
        event.preventDefault();
        if(this.index > 0){
            this.linkClick({
                currentTarget: this.links[this.index-1],
                preventDefault: function(){}
            });
        }
    }

    next(event){
        event.preventDefault();
        if(this.index < this.links.length-1){
            this.linkClick({
                currentTarget: this.links[this.index+1],
                preventDefault: function(){}
            });
        }
    }

    hashChange(event){
        event.preventDefault();
    }

    scroll(event){
        // let box = this.element.getBoundingClientRect();
        let minTop = this.header.clientHeight;
        let top = scrollY();
        if(top > minTop){
            this.element.style.position = 'fixed';
        }else{
            this.element.style.position = 'relative';
        }
        // this.element.style.top = Math.max(top, minTop) + 'px';

        if(this.links.length == 0){
            return;
        }

        let activeLink = this.links[0];
        let activeLinkCount = 0;
        for(let i = 0; i < this.links.length; i++){
            let href = this.links[i].getAttribute("href");
            let id = href.replace('#', 'bkmrk_');
            let elm = document.getElementById(id);
            let top = elm.getBoundingClientRect().top;
            if(top < 0.4*window.innerHeight){
                 activeLink = this.links[i];
                 activeLinkCount = i;
            }
        }
        if(activeLink.parentNode.className != 'active'){
            for(let i = 0; i < this.links.length; i++){
                this.links[i].parentNode.className = '';
            }
            activeLink.parentNode.className = 'active';
            let href = activeLink.getAttribute('href');
            if(href && href != '#indicators'){
                if(window.location.hash && window.location.hash.length > 1){
                    window.location.hash = 'start';
                }
            }else if(window.location.hash && window.location.hash.length > 1 &&
                    (window.location.hash.length < 5 || window.location.hash.substring(1, 5) != 'ind_')){
                window.location.hash = 'start';
            }
        }
        this.index = activeLinkCount;

        let elms = this.element.getElementsByClassName('previous');
        if(elms && elms[0]){
            elms[0].className = 'previous roicon icon-lt' + (activeLinkCount == 0? ' disabled': '');
        }

        elms = this.element.getElementsByClassName('next');
        if(elms && elms[0]){
            elms[0].className = 'next roicon icon-gt' + (activeLinkCount == this.links.length-1? ' disabled': '');
        }


    }

    linkClick(event){
        event.preventDefault();
        let elm = event.currentTarget;
        let hash = elm.getAttribute('href');
        let id = hash.replace('#', 'bkmrk_');
        let link = document.getElementById(id);
        let c = scrollTo(link, 500, true);
        c.start();
    }

    remove(){
        for(let i = 0; i < this.events.length; i++){
            this.events[i].remove();
        }
        this.events = [];
    }

}

export default Subnav;